package br.com.texeratx.boardgametimeapp.ui.screens.myclans

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.repository.ClanRepository
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class MyClansViewModel(
    private val repo: ClanRepository,
    private val sessionManager: SessionManager
) : ScreenModel {

    private val _state = MutableStateFlow(MyClansUiState())
    val state = _state.asStateFlow()

    fun load() {
        screenModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)
            val session = sessionManager.load()
            _state.value = _state.value.copy(
                userDisplayName = session?.displayName,
                userImageUrl = session?.userImageUrl
            )
            repo.getMyClans().fold(
                onSuccess = { list ->
                    _state.value = _state.value.copy(isLoading = false, clans = list)
                },
                onFailure = { e ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        error = e.message ?: "Erro ao carregar clãs"
                    )
                }
            )
        }
    }

    fun selectClan(
        clanId: Long,
        clanName: String,
        clanImageUrl: String?,
        role: String,
        onDone: () -> Unit
    ) {
        screenModelScope.launch {
            sessionManager.setActiveClan(clanId, clanName, clanImageUrl, role)
            onDone()
        }
    }

    fun logout(onDone: () -> Unit) {
        screenModelScope.launch {
            sessionManager.logout()
            onDone()
        }
    }
}
